import React, { useRef, useState } from 'react';
import * as Yup from 'yup';
import { MRT_ColumnDef } from 'material-react-table';
import FormBuilder from '../../../../../../shared/components/form-builder/form-builder';
import { IInputTcProductAdditionalDetails } from '../../../../tc-models/tc-req-dto/input-tc-product.req_dto';

interface InputTcProductAdditionalDetailsProps {
  formRef: any;
  additionalData: IInputTcProductAdditionalDetails;
  setAdditionalData: React.Dispatch<React.SetStateAction<IInputTcProductAdditionalDetails>>;
}

const InputTcProductAdditionalDetails: React.FC<InputTcProductAdditionalDetailsProps> = ({
  formRef,
  additionalData,
  setAdditionalData,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    if (drawerOpen) resetForm();
    setDrawerOpen((prev) => !prev);
  };

  const resetForm = () => {
    setAdditionalData(additionalData);
  };

  const formConfig = {
    pageName:"input-tc-product-details",
    initialValues: additionalData,
    validationSchema: Yup.object().shape({
      inputTcProductInfoTrimsExcluded: Yup.string().nullable(),
      inputTcProductInfoAssociatedTc: Yup.string().nullable(),
      inputTcProductInfoFiberLength: Yup.string().nullable(),
      inputTcProductInfoYarnCount: Yup.string().nullable(),
      inputTcProductInfoFabricWeightAndConstruct: Yup.string().nullable(),
      inputTcProductInfoFabricWeightOfFinishedProduct: Yup.string().nullable(),
      inputTcProductInfoAdditional: Yup.string().nullable(),
    }),
    sections: [
      {
        title: 'Input TC Product Additional Details',
        fields: [
          {
            label: 'Trims Excluded Info',
            name: 'inputTcProductInfoTrimsExcluded',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Trims Excluded Info',
            },
          },
          {
            label: 'Associated Info',
            name: 'inputTcProductInfoAssociatedTc',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Associated TC Info',
            },
          },
          {
            label: 'Fiber Length (mm)',
            name: 'inputTcProductInfoFiberLength',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Fiber Length',
            },
          },
          {
            label: 'Yarn Count',
            name: 'inputTcProductInfoYarnCount',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Yarn Count',
            },
          },
          {
            label: 'Fabric Weight and Construct (kg)',
            name: 'inputTcProductInfoFabricWeightAndConstruct',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Fabric Weight and Construct',
            },
          },
          {
            label: 'Fabric Weight of Finished Product (kg)',
            name: 'inputTcProductInfoFabricWeightOfFinishedProduct',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Fabric Weight of Finished Product',
            },
          },
          {
            label: 'Additional Info',
            name: 'inputTcProductInfoAdditional',
            type: 'text',
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            props: {
              placeholder: 'Enter Additional Info',
            },
          },
        ],
      },
    ],
    handleSubmit: (values: any) => {
      setAdditionalData(values);
      toggleDrawer();
    },
  };

  const columns: MRT_ColumnDef<any>[] = [
    { accessorKey: 'fiberLength', header: 'Fiber Length (mm)', minSize: 60, maxSize: 100 },
    { accessorKey: 'yarnCount', header: 'Yarn Count', minSize: 60, maxSize: 100 },
    { accessorKey: 'fabricWeightAndConstruct', header: 'Fabric Weight and Construct (kg)', minSize: 60, maxSize: 100 },
    { accessorKey: 'fabricWeightFinishedProduct', header: 'Fabric Weight of Finished Product (kg)', minSize: 60, maxSize: 100 },
    { accessorKey: 'trimsExcluded', header: 'Trims Excluded', minSize: 60, maxSize: 100 },
    { accessorKey: 'additionalInfo', header: 'Additional Info', minSize: 60, maxSize: 100 },
  ];

  const data = [
    {
      fiberLength: '20 mm',
      yarnCount: '40',
      fabricWeightAndConstruct: '150 gsm - plain',
      fabricWeightFinishedProduct: '120 gsm',
      trimsExcluded: 'None',
      additionalInfo: 'Organic certification',
    },
  ];

  return (
    <>
      <FormBuilder formConfig={formConfig} onSubmit={formConfig.handleSubmit} formRef={formRef} />
    </>
  );
};

export default InputTcProductAdditionalDetails;

